import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import Select from "react-select";
import $ from "jquery";
import './style.css'
// import makeAnimated from 'react-select/animated';

function MultiSelect(props) {
  const {
    className,
    name,
    value,
    placeholder,
    options,
    clearFilters,
    error,
    isMultiple,
    isDisabled,
    isClicked,
    isChild
  } = props;
  let [state, changeState] = useState(value);
  const [clicked, changeClickedState] = useState(isClicked);
  const [disable, changeDisableState] = useState(isDisabled);
  const [displayError, changedisplayError] = useState(false);

  
  useEffect(() => {
    let defaultState = {
      id: null,
      value: null,
      label: null,
    };
    function handleStatusChange() {
      changeState(defaultState);
    }
    async function fetchBookList() {
      await props.onChange({ name: props.name, value: defaultState });
    }
    if (clearFilters === true && value?.label !== undefined) {
      fetchBookList();
      handleStatusChange();
    }

  // alert(props.isChild);
  }, [clearFilters, value, props, state]);

  useEffect(() => {
    if (props.error === true && displayError === false) {
      changedisplayError(true);
      $("."+props.name+"-required > .css-yk16xz-control").attr(
        "style",
        "border: 1px red solid !important"
      );
      $("."+props.name+"-required > .css-yk16xz-control").addClass(
        "is-invalid state-invalid"
      );
      $("."+props.name+"-required").append(
        '<span class="invalid-feedback" style="display:block !important">This field is required</span>'
      );
    }
    if(props.name === 'area' && props.isClicked === true)
    {
      changeDisableState(false);
    }
    if(props.name === 'area' && props.isDisabled === true)
    {
      changeDisableState(true);
    }
  }, [props,displayError]);

  const handleChange = (state) => {
    let defaultState = {
      id: null,
      value: null,
      label: null,
    };
    if(name === 'district')
    {
      if(state !== null)
      {
        changeClickedState(!clicked);
        props.onClick({ name: 'areaClicked', clicked: true });
        changeState(state);
        props.onChange({ name: name, value: state });
        
      }else{
        changeClickedState(false);
        props.onClick({ name: 'districtClicked', clicked: false });
        props.onClick({ name: 'areaClicked', clicked: false });
        changeState(defaultState);
        props.onChange({ name: name, value: defaultState });
      }
    }else{
      changeState(state);
      props.onChange({ name: name, value: state });
    }
  };

  if(isChild){
    //FOR PROFILE SELECT
    return (
      <Select
        className={className}
        name={name}
        autoFocus={error}
        placeholder={placeholder}
        onChange={handleChange}
        closeMenuOnSelect={true}
        // components={animatedComponents}
        defaultValue={state}
        isMulti={isMultiple}
        isDisabled={disable}
        isClearable
        isSearchable
        withAll={true}
        options={options}
        value={value}
      />
    );
  } else{
    //FOR MAP FILTERS
    return (
      <Select
        className={className}
        name={name}
        autoFocus={error}
        placeholder={placeholder}
        onChange={handleChange}
        closeMenuOnSelect={true}
        // components={animatedComponents}
        defaultValue={state}
        isMulti={isMultiple}
        isDisabled={disable}
        isClearable
        isSearchable
        withAll={true}
        options={options}
      />
    );
  }
  
}

function mapStateToProps(state) {
  const { clearFilters } = state.map;
  return {
    clearFilters,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(MultiSelect);
